import { getUnixTime } from "date-fns"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { BIG_ONE_FIXED } from "src/constants/bigNumber"
import { AppState } from "src/state"
import useXFerRate from "./useXFerRate"

/**
 * @returns apr in %
 */
export default function usePastWeekApr(): number {
  const rate = useXFerRate()
  const data = useSelector((state: AppState) => state.xFer.barDailySnapshots)

  return useMemo(() => {
    if (
      rate.subUnsafe(BIG_ONE_FIXED).isZero() ||
      data.barDailySnapshots.length === 0
    ) {
      return 0
    }

    const currentRatio = parseFloat(rate.toString())

    const referenceRatio = data.barDailySnapshots[0].ratio
    const referenceDate = data.barDailySnapshots[0].date
    const numOfDays = Math.ceil(
      (getUnixTime(new Date()) - parseInt(referenceDate)) / 86400,
    )
    const apr =
      Math.round(
        (((currentRatio - parseFloat(referenceRatio)) * 365) / numOfDays) *
          1e20,
      ) / 1e18

    return apr
  }, [data, rate])
}
